import { useState } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "../lib/context/snackbarContext";
import {
  getUserNotification,
  markNotificationRead,
} from "../services/authenticationFn";

const useNotifications = () => {
  const { showSnackbar } = useSnackbar();
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const userData = useSelector((state) => state.userReducer.user);
  const [allNotifications, setAllNotifications] = useState([]);

  const fetchAllNotifications = async () => {
    try {
      setNotificationsLoading(true);
      const response = await getUserNotification(userData?._id);
      if (response.data.status === "success") {
        setAllNotifications(response.data.data);
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setNotificationsLoading(false);
    }
  };

  const markUserNotificationRead = async () => {
    try {
      setNotificationsLoading(true);
      const response = await markNotificationRead(userData?._id);
      if (response.data.status === "success") {
        fetchAllNotifications();
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setNotificationsLoading(false);
    }
  };

  return {
    notificationsLoading,
    allNotifications,
    fetchAllNotifications,
    markUserNotificationRead,
  };
};

export default useNotifications;
